<template lang="pug">
.event-preview-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc hide-footer)
    div(slot="modal-title")

    .event-preview(v-if="event")
      EventPreview.d-flex.justify-content-center(
        :date="_previewDate"
        :timeFrom="_timeFrom"
        :timeTo="_timeTo"
        :place="event.place"
        :title="event.title"
        :holdType="event.holdType"
        :needReply="event.needReply"
        :replyDeadline="event.replyDeadline"
        :description="event.description"
        :imageUrl="imageUrl")
  </template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { EventGetModel } from "@/commons/services/Events";
import EventPreview from "@/pc/basics/EventPreview.vue";

/**
 * ### イベントプレビューモーダル
 */
@Component({
  components: {
    EventPreview
  }
})
export default class EventPreviewModal extends Vue {
  /** 画像URL */
  @Prop({
    default: () => {
      return "";
    }
  })
  imageUrl!: string;

  /** イベント */
  @Prop({
    default: () => {
      return undefined;
    }
  })
  event!: EventGetModel;

  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  get _previewDate(): number {
    if (this.event && this.event.timeFrom) {
      return Number(String(this.event.timeFrom).slice(0, 8) + "000000000");
    }
    return 0;
  }

  get _timeFrom(): string {
    if (this.event && this.event.timeFrom) {
      if (this.event.holdType == 1) {
        return String(this.event.timeFrom);
      } else {
        return this.$dateUtil.convertTimepickerTime(this.event.timeFrom);
      }
    } else {
      return "";
    }
  }

  get _timeTo(): string {
    if (this.event && this.event.timeTo) {
      if (this.event.holdType == 1) {
        return String(this.event.timeTo);
      } else {
        return this.$dateUtil.convertTimepickerTime(this.event.timeTo);
      }
    } else {
      return "";
    }
  }
}
</script>
